<template>
  <div v-if="model.params.done">
    <span v-if="!model.hasTransport">
      <p class="text-white bg-danger p-2 mb-0" v-translate>There are no more seats available on the plane for the selected flight. Please select other departure dates</p>
    </span>
    <span v-else-if="model.results">
      <b><translate>Search results:</translate> {{ model.params.resortName}} - {{ model.params.duration }} <translate>nights</translate>:</b>
      <strong>&nbsp;{{ model.results.length }}</strong> <translate>results</translate>
      <!-- {{ model.results}} -->
    </span>
    <span v-else v-translate>
     There are no more seats available for your search.
     Please change your search criteria.
    </span>
  </div>
</template>

<script>
import model from '../services/model'
export default {
  name: 'SearchResultsSummary',
  params: ['params'],
  data () {
    return {
      model
    }
  }
}
</script>
